// extracted by mini-css-extract-plugin
export var header = "styles-module--header--YxspH";
export var active = "styles-module--active--8kqOk";
export var name = "styles-module--name--8W1AX";
export var buttons = "styles-module--buttons--wErK5";
export var logbookBtn = "styles-module--logbookBtn--GCvU2";